import { useUserActions } from "_actions";
import { Navbar, PrivateRoute } from "_components";
import { gateway_name } from "_lib/utils";
import {
  HomePage,
  ProductsPage,
  ProfilePage,
  ReportsPage,
  SmallcasePage,
} from "_pages";
import {
  ForgotPasswordPage,
  LoginPage,
  RegisterPage,
  ResetPasswordPage,
} from "_pages/_auth";
import { AdminPage } from "_pages/AdminPage";
import { GatewayAtom, UserAtom } from "_states";
import { Result } from "antd";
import axios from "axios";
import React, { useEffect } from "react";
import { Link, Outlet, Route, Routes } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";

declare global {
  interface Window {
    scDK: any;
  }
}

function App() {
  const user = useRecoilValue(UserAtom);
  const [gateway, setGateway] = useRecoilState(GatewayAtom);
  const userActions = useUserActions();
  axios.interceptors.response.use(
    (response) => {
      //   if (response.status < 300) {
      //     return Promise.reject(response);
      //   }
      return response;
    },
    (error) => {
      if (error?.response?.status === 401) {
        userActions.logout();
      }
      return error;
    }
  );

  useEffect(() => {
    if (user && user.sctoken) {
      let gatewayInstance = new window.scDK({
        gateway: gateway_name,
        smallcaseAuthToken: user.sctoken,
        config: {
          amo: true,
        },
      });
      setGateway(gatewayInstance);
    }
  }, [user]);

  return (
    <Routes>
      <Route path="auth">
        <Route path="login" element={<LoginPage />} />
        <Route path="register" element={<RegisterPage />} />
        <Route path="forgot-password" element={<ForgotPasswordPage />} />
        <Route path="reset-password" element={<ResetPasswordPage />} />
      </Route>
      <Route
        path="/"
        element={user.role === "admin" ? <AdminPage /> : <Layout />}
      >
        <Route index element={<HomePage gatewayInstance={gateway} />} />
        <Route
          path="products"
          element={<ProductsPage gatewayInstance={gateway} />}
        />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route
          path="smallcase/:iscid"
          element={<SmallcasePage gatewayInstance={gateway} />}
        />
      </Route>
      <Route path="*" element={<NoMatch />} />
    </Routes>
  );
}

const Layout = () => {
  const gateway = useRecoilValue(GatewayAtom);
  return (
    <PrivateRoute>
      <React.Suspense>
        <div className="h-screen">
          <Navbar gatewayInstance={gateway} />
          <main className="container mx-auto max-w-7xl px-2 space-y-4 pt-20 pb-4">
            <Outlet />
          </main>
        </div>
      </React.Suspense>
    </PrivateRoute>
  );
};

const NoMatch = () => {
  return (
    <div className="h-96 content-center text-center pt-20">
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Link
            to="/"
            className="rounded-lg bg-primary text-white hover:text-white px-4 py-2"
          >
            Back Home
          </Link>
        }
      />
    </div>
  );
};

export default App;
